<script>
	// Load component libraries and components
	import {
		Group,
		Image,
		Textline,
		// Input,
		Button,
		LabeledText,
		LabeledInput,
	} from "./../../../../@satelite/ui/index.js";
	import PasswordValidator from "password-validator";

	// Load libraries, modules and others
	import { querystring } from "svelte-spa-router";

	//importar helpers
	import { parseURLParams } from "../../helpers/index";

	// Obtener parametros de la url
	let params = parseURLParams($querystring);
	// console.log(params)
	// alert(params.code)
    let validateToken = params.code ? true : false; // ¿existe token?
    
    //recibo también params.app, params.code

	// console.log('no existe token en url')
	// alert(validateToken)

	import client from "@pentcloud/client";
	// console.log(client)

	// Set model
	let password = "";
	let confirmPassword = "";
	// let matchPassword = false;
	let passwordScheme = new PasswordValidator();
	let errors = [];

	let listValidate = {
		min: {
			title: " un mínimo de 8 caracteres",
			key: "min",
			icon: "",
		},
		lowercase: {
			title: "al menos 1 letra minúscula",
			key: "lowercase",
			icon: "",
		},
		uppercase: {
			title: " 1 letra mayúscula",
			key: "uppercase",
			icon: "",
		},
		digits: {
			title: " al menos 1 número",
			key: "digits",
			icon: "",
		},
		symbols: {
			title: " al menos un caracter especial",
			key: "symbols",
			icon: "",
		},
		spaces: {
			title: " no debe tener espacios",
			key: "spaces",
			icon: "",
		},
		match: {
			title: "la contraseña no coincide",
			key: "match",
			icon: "",
		},
	};

	let incomplete = false;
	let statusResponse = false;
	let statusMsg = "";
	let showLoader = false;
	let save = () => {
		incomplete = errors.length > 0 ? true : false;
		showLoader = true;
		if (errors.length < 1) {
			client.auth.confirmPassword({
					code: params.code,
                    username: params.username,
					app: params.app,
					password: password,
				}).then(function (res) {
					// console.log(res);
					showLoader = false;
					if (res.status == 200) {
						if ("error" in res.data) {
							statusResponse = 400;
							statusMsg = res.data.error.message;
						} else if ("code" in res.data) {
							statusMsg =
								"No se han cumplido todas las condiciones, verifica." &&
								res.data.code == "UNCERTAIN_STATE";
						} else {
							statusResponse = 200;
							statusMsg = res.data.message;
							setInterval(() => {
								window.location.replace(res.data.url);
							}, 3000);
						}
					}else if(res.statusCode == 400){
						statusMsg = res.message
					}
				}, (e) => {
					// console.log(e)
					statusResponse = 400;
					statusMsg = e
					showLoader = false;
				});
		} else {
			incomplete = true;
			showLoader = false;
		}
		return;
	};

	passwordScheme
		.is()
		.min(6)
		.is()
		.max(99)
		.has()
		.uppercase()
		.has()
		.lowercase()
		.has()
		.digits()
		.has()
		.not()
		.spaces()
		.has()
		.symbols();

	$: {
		errors = passwordScheme.validate(password, { list: true });
		confirmPassword == "" || confirmPassword != password
			? errors.push("match")
			: console.log("confirmed");
		// console.log(errors)
	}
	
</script>

<style>
	.lds-ring {
		display: inline-block;
		position: relative;
		width: 80px;
		height: 80px;
		margin: 0 auto;
	}
	.lds-ring div {
		box-sizing: border-box;
		display: block;
		position: absolute;
		width: 64px;
		height: 64px;
		margin: 8px;
		border: 8px solid #fff;
		border-radius: 50%;
		animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		border-color: #fff transparent transparent transparent;
	}
	.lds-ring div:nth-child(1) {
		animation-delay: -0.45s;
	}
	.lds-ring div:nth-child(2) {
		animation-delay: -0.3s;
	}
	.lds-ring div:nth-child(3) {
		animation-delay: -0.15s;
	}
	@keyframes lds-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

    .mainContainer{
        width: 100%;
        height: 100%;
        max-width: 650px;
        margin: 0 auto;
        padding: 5em;
        box-sizing: border-box;
    }
</style>


<div class="mainContainer">
	<Group layout="column" h="100%" w="100%" justifyContent="center" alignContent="center" alignItems="center">
		{#if showLoader}
			<Group let:gap gap="1em" w="100%" alignContent="center">
				<div class="lds-ring">
					<div />
					<div />
					<div />
					<div />
				</div>
			</Group>
		{/if}
		{#if !validateToken && !statusResponse && !showLoader}
			<Group let:gap gap="1em" w="100%">
				<LabeledText label="Token inválido" text="El token de esta solicitud no es válido o ha caducado, por favor inicie el proceso nuevamente." size="1.2em" align="center" color="#6F6F6F" />
			</Group>
		{:else if validateToken && !statusResponse && !showLoader}
        <img src="{params.app || 'pentcloud'}.svg" alt="Pentcloud.com" width="150px" style="padding:0 0 2em 0">
        <LabeledText label="Cambiar contraseña" text="Ingresa y confirma tu nueva contraseña, recuerda cumplir con todos los criterios." size="2em" align="center" color="#262626" labelSize="1em" colorLabel="#6F6F6F" labelWeight={600} />
			<Group let:gap gap="1em" w="100%" margin="calc(0.5em + 1em ) 0em 0em 0em">
				<LabeledInput label="Contraseña nueva" placeholder="Contraseña" size="1em" type="password" color="#6F6F6F" weight="500" margin="0em 0em calc(0.5em + {gap} ) 0em" w="100%" bind:value={password} inputColor="#8D8D8D" background="#f4f4f4" />
				<LabeledInput label="Confirmar nueva contraseña" placeholder="Contraseña" type="password" size="1em" color="#6F6F6F" weight="500" margin="0em 0em 1.5em 0em" w="100%" bind:value={confirmPassword} inputColor="#8D8D8D" background="#f4f4f4" />
			</Group>
            {#each Object.keys(listValidate) as item, i}
			    <Group w="100%" margin="0 0 0.5em 0" layout="row">
                    <img src="{errors.includes(item) ? 'error' : 'success'}.svg" alt="Pentcloud.com" height="16px" style="padding:0 1em 0 0">
				    <Textline color="#6F6F6F" weight="500" margin="0" size="0.8em">
                        La contraseña {#if item != 'match' && item != 'spaces'}debe tener{/if}
						{listValidate[item].title}
                    </Textline>
                </Group>
            {/each}
			<Group margin="2em 0" w="100%" alignItems="flex-end">
                <Button rounded="10px" background="#0000ff" color="#fff" text="Confirmar" on:click={save} w="fit-content" />
            </Group>
			{#if incomplete}
				<Textline color="#6F6F6F" weight="500" margin="0em 0em calc(0.5em + 1em ) 0em">
					No se han cumplido todas las condiciones, verifica.
				</Textline>
			{/if}
		{/if}
		{#if statusResponse == 200 && !showLoader}
			<Group let:gap gap="1em" w="100%">
				<LabeledText label="Contraseña actualizada" text="Hemos actualizado tu contraseña exitosamente, te redirigiremos al login en unos segundos o pueder ir ahora" size="1.2em" align="center" color="#6F6F6F" />
				<Textline color="#6F6F6F" size="0.9em" margin="0em 0em calc(0.5em + {gap} ) 0em" align="center">
					{statusMsg}
				</Textline>
			</Group>
		{:else if statusResponse == 400 && !incomplete && !showLoader}
			<Group let:gap gap="1em" w="100%">
				<LabeledText label="Hubo un error en la solicitud" text={statusMsg} size="1.2em" align="center" color="#6F6F6F" />
			</Group>
		{/if}
	</Group>
</div>
